import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";
import { notifierStore } from "src/framework/store/NotifierStore";

export interface Atributo {
    id: string
    titulo: string
    sufixo: string
    descricao: string
    tipo: number
    subtipo: number
    entidade_codigo: any
    valor_padrao: any
    valores: Valores
    obrigatorio: boolean
    mascara: any
    ordem: number
    tamanho: number
    precisao: number
    multiplo: boolean
    aceitar_negativo: boolean
    calculado: boolean
}

export interface Valores {
    enum: Enum[]
}

export interface Enum {
    text: string
    value: number
}

class AtributosProvider extends AProvider {
    constructor() {
        super("/cadastros/atributos");
    }

    async buscarAtributos(): Promise<Atributo[]> {
        const request: IDataRequest = { url: this.path }
        const response: IDataResponse<Atributo[]> = await api.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data
        }

        throw new Error(`Erro ao buscar atributos: ${response.message}`);
    }
}

export { AtributosProvider }